import Splide from '@splidejs/splide';

function initSliders() {
    const elms = document.getElementsByClassName('splide');
    for (let i = 0, len = elms.length; i < len; i++) {
        new Splide(elms[i], {
            type: 'slide',
            perPage: 1,
            arrows: false,
            trimSpace: true,
            padding: 0,
            gap: '20px',
            breakpoints: {
                //
            },
        }).mount();
    }
}

$(document).ready(function () {
    initSliders();
});